import React from "react";
import { VehicleSkeletonLoader } from "./VehicleSkeletonLoader";

type Props = {
  count?: number;
  className?: string;
};

export function VehicleListSkeleton({ count = 6, className = "" }: Props) {
  return (
    <div
      className={`grid grid-cols-1 md:grid-cols-3 gap-4 w-full ${className}`}
    >
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="h-64">
          <VehicleSkeletonLoader />
        </div>
      ))}
    </div>
  );
}
